import React from 'react';
import PropTypes from 'prop-types';
import { DownloadArrows, DownloadOverlayCloseButton, DownloadOverlayText } from '../components/';
import { DownloadArrowDirectionEnum, SupportedBrowserEnum } from '../DownloadOverlayConstants';

const bowser = require('bowser');

class DownloadOverlay extends React.Component {
  static getBrowserType() {
    if (bowser.firefox) {
      return SupportedBrowserEnum.FIREFOX;
    }
    if (bowser.msie) {
      return SupportedBrowserEnum.MSIE;
    }
    return null;
  }

  static isSupportedBrowser(browserType) {
    return browserType === SupportedBrowserEnum.FIREFOX ||
      browserType === SupportedBrowserEnum.MSIE;
  }

  constructor(props) {
    super(props);
    this.onHide = this.onHide.bind(this);
    let downloadArrowDirection;

    let browserType = this.props.browserType;
    if (!browserType) {
      browserType = DownloadOverlay.getBrowserType();
    }

    switch (browserType) {
      case SupportedBrowserEnum.FIREFOX:
        downloadArrowDirection = DownloadArrowDirectionEnum.UP;
        break;
      case SupportedBrowserEnum.MSIE:
        downloadArrowDirection = DownloadArrowDirectionEnum.DOWN;
        break;
      default:
        // currently we don't show any download overlay for remaining browsers
        break;
    }

    this.state = {
      show: this.props.show,
      activeDownloadArrowIdx: 0,
      numberOfDownloadArrows: this.props.numberOfDownloadArrows,
      downloadArrowDirection,
      browserType,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => this.tick(), 1000);
  }

  componentWillReceiveProps(nextProps) {
    this.state.show = nextProps.show;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onHide() {
    return this.props.hideDownloadOverlay();
  }

  tick() {
    this.setState(() => {
      let activeIdx;
      if (this.state.downloadArrowDirection === DownloadArrowDirectionEnum.DOWN ||
          this.state.downloadArrowDirection === DownloadArrowDirectionEnum.RIGHT) {
        activeIdx = this.state.activeDownloadArrowIdx + 1;
      }
      if (this.state.downloadArrowDirection === DownloadArrowDirectionEnum.UP ||
          this.state.downloadArrowDirection === DownloadArrowDirectionEnum.LEFT) {
        activeIdx = this.state.numberOfDownloadArrows + (this.state.activeDownloadArrowIdx - 1);
      }
      return ({
        activeDownloadArrowIdx: Math.abs(activeIdx % this.state.numberOfDownloadArrows),
      });
    });
  }

  render() {
    const browserType = this.state.browserType;
    if (!this.state.show || !DownloadOverlay.isSupportedBrowser(browserType)) {
      return (null);
    }
    const styles = {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      zIndex: 9999,
      color: 'white',
      display: 'block',
    };

    const closeButtonStyle = {
      position: 'absolute',
    };
    const downloadArrowsStyle = {
      position: 'absolute',
    };

    const textStyle = {
      position: 'absolute',
      width: 200,
    };

    switch (browserType) {
      case SupportedBrowserEnum.FIREFOX:
        closeButtonStyle.top = 10;
        closeButtonStyle.right = 20;
        downloadArrowsStyle.top = 10;
        downloadArrowsStyle.right = 116;
        textStyle.top = 80;
        textStyle.right = 30;
        break;
      case SupportedBrowserEnum.MSIE:
        closeButtonStyle.bottom = 170;
        closeButtonStyle.right = 150;
        downloadArrowsStyle.bottom = 70;
        downloadArrowsStyle.right = 400;
        textStyle.bottom = 140;
        textStyle.right = 200;
        textStyle.width = 400;
        break;
      default:
        // currently we don't show any download overlay for remaining browsers
        break;
    }

    const overlayButtonStyles = {
      width: '100%',
      height: '100%',
      backgroundColor: 'Transparent',
      border: 'none',
      cursor: 'default',
      outline: 'none',
    };

    return (
      <div className={'download-overlay'} style={styles}>
        <button style={overlayButtonStyles} onClick={this.onHide} />
        <div style={closeButtonStyle}>
          <DownloadOverlayCloseButton
            onClick={this.onHide}
          />
        </div>
        <div className={'download-overlay-text-container'} style={textStyle}>
          <DownloadOverlayText browserType={browserType} />
        </div>
        <div style={downloadArrowsStyle}>
          <DownloadArrows
            activeDownloadArrowIdx={this.state.activeDownloadArrowIdx}
            numberOfDownloadArrows={this.state.numberOfDownloadArrows}
            downloadArrowDirection={this.state.downloadArrowDirection}
          />
        </div>
      </div>
    );
  }
}

DownloadOverlay.propTypes = {
  show: PropTypes.bool,
  hideDownloadOverlay: PropTypes.func.isRequired,
  numberOfDownloadArrows: PropTypes.number,
  browserType: PropTypes.oneOf([
    SupportedBrowserEnum.FIREFOX,
    SupportedBrowserEnum.MSIE,
    SupportedBrowserEnum.MSEDGE,
  ]),
};

DownloadOverlay.defaultProps = {
  show: false,
  numberOfDownloadArrows: 3,
  browserType: null,
};

export default DownloadOverlay;



// WEBPACK FOOTER //
// ./src-react/download-overlay/containers/DownloadOverlay.jsx